import { render, staticRenderFns } from "./FreeShipping.vue?vue&type=template&id=128fcc3e&"
import script from "./FreeShipping.vue?vue&type=script&lang=js&"
export * from "./FreeShipping.vue?vue&type=script&lang=js&"
import style0 from "./FreeShipping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports